
/* STICKY ADD TO CART BAR */
const stickySelect = document.getElementById('product-quantity-select-sticky');

stickySelect.addEventListener('change', function() {
	const selectedStickyValue = stickySelect.value;

	const quantity_select = document.getElementById('product-quantity-select');
	const quantity_input = document.getElementById('product-quantity-input');

	quantity_select.value = selectedStickyValue;
	quantity_input.value = selectedStickyValue;
});

const stickyAtc = document.getElementById('sticky-atc');

stickyAtc.addEventListener('click', function() {
	const productMain = stickyAtc.closest('.product--container');
	const submitButton = productMain.querySelector('button[type="submit"]');
	submitButton.click();
});

let productGalleryApi;
let productGalleryTumbsApi;

function product_galleries(){
	/* Main Carousel */
	const emblaNode = document.querySelector('.product_gallery')
	const options = { loop: false, inViewThreshold: 0 }
	const plugins = [EmblaCarouselAutoHeight()]
	productGalleryApi = EmblaCarousel(emblaNode, options, plugins);


	function logSlidesInView(productGalleryApi,selectedIndex) {
		//console.log(productGalleryApi.slidesInView()[0] )

		const emblaThumbs = document.querySelectorAll('.product_gallery-thumbs .product_gallery__slide');

		emblaThumbs.forEach(otherThumb => {
			otherThumb.classList.remove('selected-thumb');
		});

		const emblaNewThumb = document.querySelector('#thumb-slide-'+selectedIndex);
		emblaNewThumb.classList.add('selected-thumb');
	}

	productGalleryApi.on('select', () => {
		const selectedIndex = productGalleryApi.selectedScrollSnap();
		logSlidesInView(productGalleryApi,selectedIndex)
	});


	/* Thumbnail Carousel */
	const emblaTumbsNode = document.querySelector('.product_gallery-thumbs')
	const Tumbsoptions = { loop: false, align: "start", skipSnaps: true }
	productGalleryTumbsApi = EmblaCarousel(emblaTumbsNode, Tumbsoptions);


	/* No longer needed
	document.querySelectorAll('.embla-thumb').forEach(thumb => {
		console.log('found thumb');

		thumb.addEventListener('click', () => {
			productGalleryApi.scrollTo(thumb.dataset.slide)

			console.log('test');
		});
	});*/
}
product_galleries();


function productVariantChange(){
	//console.log('variant change');
	const optionRadios = document.querySelectorAll('.product-options-style-radio .option-value-input');
	const selectedVariantIdInput = document.querySelector('#selected-variant-id input');
	const productPrice = document.querySelector('.product--price ');
	const productComparePrice = document.querySelector('.product--compare-at-price');

	function updateSelectedVariant() {

		const selectedOptions = {};
		optionRadios.forEach(radio => {
			if (radio.checked) {
				selectedOptions[`option${radio.dataset.optionIndex}`] = radio.value;
			}
		});

		//Check each option to see if the matching variant exists and is available
		optionRadios.forEach(radio => {
			const optionName = radio.getAttribute('name').replace('-', '');
			let OptionOptions = { ...selectedOptions };

			if (optionName in OptionOptions) {
				OptionOptions[optionName] = radio.value;
			}

			const matchingVariant = product_variants.find(variant => {
				return Object.keys(OptionOptions).every(optionName => {
					return variant[optionName] === OptionOptions[optionName];
				});
			});

			if (matchingVariant && matchingVariant.available) {
				radio.nextElementSibling.style.display = "flex"
			} else {
					if (radio.nextElementSibling && radio.nextElementSibling.classList.contains('option-type-frame')) {
				radio.nextElementSibling.style.display = "none"
				}
			}
		});

		const selectedVariant = product_variants.find(variant => {
			return Object.keys(selectedOptions).every(optionName => {
				return variant[optionName] === selectedOptions[optionName];
			});
		});

		if (selectedVariant) {
			console.log('selectedVariant')
			selectedVariantIdInput.value = selectedVariant.id;
			updateProductUrl(selectedVariant.id);

			fetch(window.location.href+'&sections='+section_id)
			.then(response => response.text())
			.then(html => {

				parsedHTML = JSON.parse(html)

				const parsedSection = parsedHTML[section_id]
				const parser = new DOMParser();
				const sectionHTML = parser.parseFromString(parsedSection, 'text/html');

				const sections_to_update = [
					".product-form--atc",
					"#product-price-selector"
				]

				//console.log( sectionHTML )
				sections_to_update.forEach(update_id => {
					//console.log( update_id )
					if (document.querySelector(update_id)) {
						document.querySelector(update_id).innerHTML = sectionHTML.querySelector(update_id).innerHTML;
					}
				});
			})
			.catch(e => {
				console.error(e);
			});

		} else {
			const productCta = document.querySelector('.product-form--atc-qty');
			const productCtaButton = productCta.querySelector('#AddToCart');

			if (productCtaButton) {
				productCtaButton.classList.add('disabled');
			}
		}
	}

	function updateProductUrl(variantId) {
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('variant', variantId);
		window.history.replaceState({}, '', currentUrl);
	}

	optionRadios.forEach(radio => {
		radio.addEventListener('change', updateSelectedVariant);
	});

	//Check if we have a product with multiple options (gift cards)
	const product_options_radio = document.querySelector('.product-options-style-radio');
	if (product_options_radio) {
		updateSelectedVariant();
	}
}

document.addEventListener('DOMContentLoaded', function () {
	productVariantChange();
});

function ajax_add_to_cart(){
	// Add To Cart
	// Not for bundles or 'all colours' products
	const productForm = document.querySelector('form.ajax-submit');
	productForm.addEventListener('submit', (event) => {
		event.preventDefault();

		const selectedId = productForm.querySelector("input[name='id']").value;
		let form_properties = {}

		const inputProperties = document.querySelectorAll('[name*="properties"]');
		inputProperties.forEach(input => {
			let nameValue = input.name;
			nameValue = nameValue.replace('properties[', '').replace(']', '');

			if ((input.type === "text" || input.type === "email" || input.tagName.toLowerCase() === "textarea") && input.value.trim() !== "" ) {
				form_properties[nameValue] = input.value
			}
			if (input.type === "radio" && input.checked){
				form_properties[nameValue] = input.value;
			}
			if (input.type === "checkbox" && input.checked){
					if (input.id === "recipient-checkbox") {
					form_properties[nameValue] = true
				} else {
					form_properties[nameValue] = input.value
				}
			}
			if ( input.type === "date"){
				form_properties[nameValue] = input.value
			}
		});

		//Check if any upsell selected
		let selected_variants = [
			{
				quantity: 1,
				id: selectedId
			}
		];

		const upsellInputs = document.querySelectorAll('.product-upsell input');

		upsellInputs.forEach(input => {
			if (input.checked) {
				const selected_variant = {
					quantity: 1,
					id: input.value
				}
				selected_variants.push(selected_variant);
			}
		});

		console.log('ajax_add_to_cart')
		console.log(selectedId);
		console.log(form_properties);

		if (selected_variants.length > 	1) {
			//If adding upsell
			addProductsToCart(selected_variants)
		} else {
			//Add single product
			if (selectedId) {
				addProductToCart(selectedId,form_properties)
			}
		}
	});
}
ajax_add_to_cart();

function init_product_upsell(){
	const upsellInputs = document.querySelectorAll('.product-upsell input');
	let productPrice = document.querySelector('.price--main').dataset.price;
	let productComparePrice = document.querySelector('.price--compare-at').dataset.price;

	function updateUpsellPrices(productPrice,productComparePrice){
		const updatedProductPrice = productPrice / 100.00
		const updatedComparePrice = productComparePrice / 100.00
		document.querySelector('.price--main').innerHTML = `$${updatedProductPrice.toFixed(2)} ${cart_currency}`;
		document.querySelector('.price--compare-at').innerHTML = `$${updatedComparePrice.toFixed(2)} ${cart_currency}`;
	}

	upsellInputs.forEach(input => {
		input.addEventListener('change', () => {
			if (input.dataset.price) {
				if (input.checked) {
					productPrice = Number(productPrice) + Number(input.dataset.price)
					productComparePrice = Number(productComparePrice) + Number(input.dataset.price)
				} else {
					productPrice = document.querySelector('.price--main').dataset.price;
					productComparePrice = document.querySelector('.price--compare-at').dataset.price;
				}
				updateUpsellPrices(productPrice,productComparePrice);
			}
		});

		if (input.classList.contains('auto-add-true')) {
			input.checked = true;
		}

		input.dispatchEvent(new Event('change'));
	});
}
init_product_upsell();

/* Function never used 17/7/24
function getSelectedValue() {
	const
	selectedRadio = document.querySelector('input[name="multi-quantity"]:checked'),
	afterpayParagraph = document.getElementById('afterpay-wrap');
	multiBuyATC = document.getElementById('add-multi-pack'),
	productPrice = document.querySelector('.price--main');

	AddToCartBtn = document.getElementById('AddToCart');

	productPrice.innerHTML = event.target.dataset.price;

	if (selectedRadio) {
		ga_event('multi_buy','Quantity Change',selectedRadio.value);

		if ( selectedRadio.value == '1' ) {
			const selectedValue = selectedRadio.value;
			AddToCartBtn.style.display = 'block'
			multiBuyATC.style.display = 'none'
			afterpayParagraph.style.display = 'block'
		} else {
			AddToCartBtn.style.display = 'none'
			multiBuyATC.style.display = 'block'
			afterpayParagraph.style.display = 'none'
		}
	} else {
		//console.log("No radio button with name 'multi-quantity' is selected.");
	}
}

function multibuy(){

	$('#add-multi-pack').click(function(e){

		const button = $(this);

		let
			selected_variants = [],
			bundle_type = "multi_buy";

		const
			quantity = document.querySelector('input[name="multi-quantity"]:checked'),
			variantID = document.querySelector('input[name="id"]');

		if ( product_object.type == 'Towel'){
			bundle_type = "multi_buy_towel";
		}

		selected_variant = {
			quantity: quantity.value,
			id: variantID.value,
			properties: {
				'_bundle': bundle_type
			}
		}
		selected_variants.push(selected_variant)

		button.prop("disabled", true).html('Adding To Cart');

		ga_event('multi_buy','Add To Cart',quantity.value);
		addProductsToCart(selected_variants,button)
	});

	const multiBuyInputs = document.querySelectorAll('input[name="multi-quantity"]');
	multiBuyInputs.forEach(radio => radio.addEventListener('change', getSelectedValue));
}
multibuy();*/



//SKIO Custom

//Skio Sales text:

document.addEventListener('DOMContentLoaded', () => {
	const target = document.querySelector('.skio-group-content');
	if (!target) return;
	if (target.nextElementSibling?.classList.contains('skio-benefits')) return; // prevent duplicate

	const html = `
	<ul class="skio-benefits" style="list-style:none; padding:0;">
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Each box plants 4 trees
		</li>
		<li style="display:none; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Free Shipping on subscriptions
		</li>
		<li style="display:none; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			FREE shipping on every order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Free Gift Every 3rd Order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Cancel anytime
		</li>
	</ul>`;
	target.insertAdjacentHTML('afterend', html);
});

document.addEventListener('DOMContentLoaded', () => {
	const qty = document.querySelector('.quantity-swatches');
	const qtyInput = document.getElementById('product-quantity-input');

	const priceMain = document.querySelector('.price--main');
	if (priceMain) {
		const currentPrice = Number(priceMain.dataset.price);
		const perBar = currentPrice / 1200.00
		document.querySelectorAll('.skio-group-topline').forEach(el => {
			if (el.textContent.includes('Try Once')) {
				el.childNodes.forEach(node => {
					if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Try Once') {
						node.textContent = `Try Once ($${perBar.toFixed(2)} per bar)`;
					}
				});
			}
		});

		if (qty) {
			// Multi pack selector
			document.querySelectorAll('input[name="pack-size"]').forEach(radio => {
				radio.addEventListener('change', e => {
					qtyInput.value = e.target.value;
					discountValue = e.target.dataset.discount;

					const saveTxt = document.querySelector('.skio-save');
					if (saveTxt){
						saveTxt.innerHTML = `Save ${discountValue}%`
					}

					const compareAt = document.querySelector('.price--compare-at');

					if (compareAt) {
						const compareAtPrice = Number(compareAt.dataset.price);
						const salePrice = compareAtPrice * (discountValue / 100) / 100.00;
						const priceTxt = document.querySelector('.skio-price');
						if (priceTxt){
							priceTxt.innerHTML = `$${salePrice.toFixed(2)}`;
						}
					}
				});
			});



			const showQty = () => qty.classList.remove('is-closed');
			const hideQty = () => {
				qty.classList.add('is-closed');
				if (qtyInput) qtyInput.value = 1;
			};

			// Labels
			const oneTimeLabels = document.querySelectorAll('.skio-group-label[for*="skio-one-time"]');
			const otherLabels   = document.querySelectorAll('.skio-group-label[for]:not([for*="skio-one-time"])');

			// Clicks on labels
			oneTimeLabels.forEach(l => l.addEventListener('click', hideQty));
			otherLabels.forEach(l => l.addEventListener('click', showQty));
		} else {
			// Hardcoded for discounted product with just the option to buy 1 pack or subscribe
			const saveTxt = document.querySelector('.skio-save');
			if (saveTxt) {
				saveTxt.innerHTML = `Save 40%`
			}
		}
	}
});
